import { action, computed, observable, runInAction, makeObservable } from 'mobx';
import { eventBus, subscribe } from 'mobx-event-bus2';

import { EventType } from 'utils/events/constants';
import { Indexable } from 'utils/types';
import { ResolutionReasonResponse } from 'utils/api/modules/alarms/alarms.types';

import Logger from 'utils/logger';

import API from '../../utils/api';
import DataMixin from '../../utils/stores/DataMixin';
import RootStore from '../Root';

export default class ConfigStore extends DataMixin {
  @observable resolutionReasons: ResolutionReasonResponse[] = [];

  constructor(rootStore: RootStore, api: typeof API) {
    super(rootStore, api);

    makeObservable(this);

    eventBus.register(this);
  }

  @action.bound
  async loadConfig(): Promise<void> {
    if (!this.store.session.user) {
      this.isLoaded = true;
      return;
    }

    this.isLoaded = false;

    try {
      const resolutionReasonsResponse = await this.api.alarms.loadResolutionReasons()();

      runInAction(() => {
        this.resolutionReasons = resolutionReasonsResponse ? resolutionReasonsResponse.data : [];
        this.isFailure = false;
      });
    } catch (e) {
      runInAction(() => {
        this.isFailure = true;
      });
      Logger.error('Invalid load config API response', e);
    } finally {
      runInAction(() => {
        this.isLoaded = true;
      });
    }
  }

  @computed get resolutionReasonOptions(): Indexable<string> {
    return this.resolutionReasons.reduce((accumulator: Indexable<string>, resolutionReason): Indexable<string> => {
      accumulator[resolutionReason.uuid] = resolutionReason.name;
      return accumulator;
    }, {});
  }

  @subscribe(EventType.LoggedOut)
  @action
  reset(): void {
    super.reset();

    this.resolutionReasons = [];
  }
}
